import { z } from 'zod';

import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { getClickToPayFilterFormSchema } from '../components/ClickToPayFilter/helpers/getClickToPayFilterFormSchema';

const clickToPayFilterFormSchema = getClickToPayFilterFormSchema();

export const clickToPayValidateSearchSchema = defaultPagingSchema.extend({
	openedCard: z.string().optional().catch(undefined),
	filter: clickToPayFilterFormSchema.optional().catch(undefined),
});
